function navigateToPage(e: Event): void {
  const target = e.target as HTMLSelectElement
  const url = target.value

  // TODO Turbolinks.visit does not currently work here,
  // as the pages when restored from cache don't respond to events
  const win: Window = window
  win.location = url
}

export default (): (() => void) => {
  const unsubscribers: Array<() => void> = []

  window.onDomLoad(function ($dom) {
    const doc = $dom[0]

    const headers = doc.querySelectorAll(
      "[data-behaviour='adjustments-page-header']"
    )

    headers.forEach((header) => {
      const actionsSelect = header.querySelector(
        '#actionsSelectElement'
      ) as HTMLSelectElement
      const downloadSelect = header.querySelector(
        '#downloadSelectElement'
      ) as HTMLSelectElement

      if (actionsSelect) {
        actionsSelect.addEventListener('change', navigateToPage)
        unsubscribers.push(() =>
          actionsSelect.removeEventListener('change', navigateToPage)
        )
      }

      if (downloadSelect) {
        downloadSelect.addEventListener('change', navigateToPage)
        unsubscribers.push(() =>
          downloadSelect.removeEventListener('change', navigateToPage)
        )
      }
    })
  })

  return () => {
    unsubscribers.forEach((unsubscriber) => unsubscriber())
  }
}
